import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const getClassNamesOfItemData = status => {
  let textColor = '';

  switch (status) {
    case 'done':
      textColor = 'text-success';
      break;
    case 'failed':
      textColor = 'text-danger';
      break;
    case 'not_done':
      textColor = 'text-warning';
      break;
    default:
      break;
  }
  return `pt-3 pb-3 ${textColor}`;
};

const JobCounterLink = ({ job, status }) => {
  const { t } = useTranslation();

  const value = parseInt(job[`${status}_objects`]) || 0;

  if (status === 'pending' && value === 0) {
    return null;
  }

  return (
    <Link to={`/items/${job.id}/${status}`} className={getClassNamesOfItemData(status)}>
      <h5 className="m-0 fw-light">{value}</h5>
      <small>{t(`bots.jobs.card.${status}`)}</small>
    </Link>
  );
};

export default JobCounterLink;
